import React from 'react';

import './tracksidehospitality.scss';
import placeholder from "~/assets/placeholder-image.svg";
import Translate from "~/Components/ContentTranslate/Translate";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

export default function TracksideHospitality ({data}) {

	return (
		<div className="tracksidehospitality text-left">
			<div className="container">
                {data.map(row => (
                    <div className="row mb-5">
                        <div className="col-lg-5 col-12 no-gutters-col">
                            <div className="background" style={{backgroundImage: `url(${row.image?.download_url || placeholder})`}} />
                        </div>
                        <div className="content col-lg-7 col-12">
                            <h4><Translate model={row} field="name" /></h4>

                            <p className="pre-line"><Translate model={row} field="description" /></p>

                            <div className="useful-info col-12 p-0">
                                <h4><TextTranslate name="word-useful-information" fallback="Useful Information"/></h4>
                                <p className="pre-line"><Translate model={row} field="info" /></p>
                            </div>
                        </div>
                    </div>
                ))}
			</div>
		</div>
	)
}

